export default "__VITE_ASSET__CnSOQ7tc__"